import type from '../actionsType';

const onBreadcrumbButton = (payload) => ({type: type.SET_BREADCRUMB_LINK_BUTTON, payload : payload});

export {
    onBreadcrumbButton
}